import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type PieChartIconProps = IconProps;

export const PieChartIcon: FC<PieChartIconProps> = ({
  iconColor = '#475467',
  className,
  ...props
}) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#pie-chart-icon-clip)">
      <path
        d="M14.1404 10.5935C13.7163 11.5964 13.053 12.4803 12.2084 13.1677C11.3637 13.8551 10.3636 14.3251 9.29539 14.5366C8.22717 14.7482 7.12338 14.6949 6.08053 14.3813C5.03768 14.0678 4.08752 13.5035 3.31311 12.7379C2.53871 11.9723 1.96364 11.0286 1.63819 9.98943C1.31274 8.95023 1.24681 7.84712 1.44616 6.77655C1.64552 5.70598 2.1041 4.70055 2.7818 3.84815C3.4595 2.99575 4.33569 2.32234 5.33377 1.88679M14.1596 5.4489C14.4265 6.09321 14.5902 6.77437 14.6458 7.46736C14.6595 7.63856 14.6664 7.72416 14.6324 7.80126C14.604 7.86568 14.5477 7.92663 14.4858 7.96008C14.4116 8.00013 14.319 8.00013 14.1338 8.00013H8.53377C8.34708 8.00013 8.25374 8.00013 8.18244 7.9638C8.11971 7.93184 8.06872 7.88085 8.03676 7.81812C8.00043 7.74682 8.00043 7.65348 8.00043 7.46679V1.86679C8.00043 1.68155 8.00043 1.58893 8.04048 1.51478C8.07393 1.45285 8.13489 1.39659 8.1993 1.36819C8.2764 1.3342 8.362 1.34106 8.5332 1.35478C9.22619 1.41034 9.90735 1.57405 10.5517 1.84093C11.3605 2.17596 12.0954 2.66703 12.7145 3.28608C13.3335 3.90514 13.8246 4.64007 14.1596 5.4489Z"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </g>
    <defs>
      <clipPath id="pie-chart-icon-clip">
        <rect fill="white" height="16" width="16" />
      </clipPath>
    </defs>
  </svg>
);
